module.exports = __webpack_public_path__ + "img/palm2_4.1c54edaa.png";